import useCommandFlowStore from "../../store/commandFlowStore";
import { getTranslation } from "../../config/translations";

/**
 * Creates a translation function that uses translations from the Zustand store
 * @returns {Function} Translation function (t)
 */
export const createTranslationFunction = () => {
  const translations = useCommandFlowStore.getState().translations;
  return (key, replacements = {}) => getTranslation(key, translations, replacements);
};

/**
 * Gets the current translation function using store translations
 * @returns {Function} Translation function (t)
 */
export const getTranslationFunction = () => {
  return createTranslationFunction();
};
